import { Component } from '@angular/core';

@Component({
  selector: 'orgbrain-bank-id-cheat',
  templateUrl: './bank-id-cheat.component.html',
  styleUrls: ['./bank-id-cheat.component.scss'],
    standalone: false
})
export class BankIdCheatComponent {}
